/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Close_Window_LogInputs */



/**
* | output |
* | --- |
* | "### You can close this window now. ###" |
*
* @param {Drastic_Tech_Close_Window_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_close_window_log = /** @type {((inputs?: Drastic_Tech_Close_Window_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Close_Window_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("### Vous pouvez fermer cette fenetre maintenant. ###")
	if (locale === "de") return /** @type {LocalizedString} */ ("### Sie können dieses Fenster jetzt schließen. ###")
	if (locale === "it") return /** @type {LocalizedString} */ ("### Ora puoi chiudere questa finestra. ###")
	if (locale === "ru") return /** @type {LocalizedString} */ ("### Теперь вы можете закрыть это окно. ###")
	if (locale === "es") return /** @type {LocalizedString} */ ("### Puedes cerrar esta ventana ahora. ###")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您现在可以关闭此窗口了。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("### このウィンドウは閉じて構いません。 ###")
	if (locale === "hi") return /** @type {LocalizedString} */ ("### अब आप इस विंडो को बंद कर सकते हैं। ###")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você pode fechar esta janela agora.")
	return /** @type {LocalizedString} */ ("### You can close this window now. ###")
});